<template>
  <div>
    <img v-if="msg.srcUrl==='loading'" class="img-loading" src="@/assets/images/imgLoad.png" alt="加载中..." />
    <div v-else :class="['video-msg-wrapper',{'is-self-video':isSelf}]">
      <img v-if="msg.msgTip&&msg.msgTip==='isDelete'" style="width: 16px;height: auto;position:absolute;left:-26px;top:60px" src="@/assets/images/field.png" alt="上传失败" />
      <div class="video-cover-container" @click="handleClickShowVideoPreview">
        <div class="cover-image-wrapper">
          <img :src="videoCoverAddress" alt="" />
        </div>
        <div class="mask-wrapper">
          <div class="play-btn"></div>
          <div class="video-time">
            <p>{{ videoDuration }}</p>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div v-show="videoPreview" class="video-mask-container">
          <div class="video-container">
            <div class="close-btn-wrapper">
              <div class="icon-close" @click="handleClosePreview"></div>
            </div>
            <video
              ref="videoBox"
              class="video-content"
              :src="videoPlayAddress"
              :poster="videoCoverAddress"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              webkit-playsinline
              playsinline
              @canplay="handleListenLoadPlay"
              @timeupdate="videoTimeUpdate"
            >
            </video>
            <div v-show="videoIsItPlayable" class="controls">
              <div class="fixed-container">
                <div class="clickBtn">
                  <div v-if="currentPausedStatus" class="playbtn" @click="handlePlayMove"></div>
                  <div v-else class="pauseBtn" @click="handlePauseMove"></div>
                </div>
                <div class="progress-container">
                  <span class="current">{{ videoCurrentTime }}</span>
                  <div ref="progress" class="progress">
                    <div ref="duration" class="duration" :style="{ width: progressWidth + '%' }"></div>
                    <span
                      ref="durationIcon"
                      class="dragAndDrop"
                      @touchstart="handleTouchStart"
                      @touchmove="handleTouchMove"
                      @touchend="hadnleTouchEnd"
                      @mousedown="handleTouchStartPc"
                      @mousemove="handleTouchMovePc"
                      @mouseup="hadnleTouchEndPc"
                    ></span>
                  </div>
                  <span class="totle">{{ videoDuration }}</span>
                </div>
                <div class="down-load" @click="handleClickDownVideo"></div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { realFormatSecond, getDeviceType } from '@/common/js/utils'
import axios from 'axios'
/**
   * 视频类型消息显示
   */
export default {
  name: 'VideoMsg',
  props: {
    msg: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      videoPreview: false,
      videoPlayAddress: '', // 视频播放地址
      videoIsItPlayable: false,
      videoCurrentTime: '', // 视频当前播放时间
      videoDuration: '', // 视频总时间
      lastTime: '',
      currentPausedStatus: true, // 播放暂停状态, true为暂停, false为播放
      progressWidth: 0,
      offSetDistance: 0, // 拖拽开始的偏移距离
      isMoveEnter: false
    }
  },
  computed: {
    isSelf() {
      const { sendType } = this.msg
      return !(sendType && sendType.toUpperCase() === 'SEND' || sendType.toUpperCase() === 'AUTO_REPLY')
    },
    videoCoverAddress() {
      const { picUrl } = this.msg
      return process.env.VUE_APP_CHAT_SERVER + '/fastDfs/download?recordFile=' + picUrl
    }
  },
  mounted() {
    if (getDeviceType().iPhone) {
      this.videoIsItPlayable = true
    }
  },
  methods: {
    handleClickShowVideoPreview() {
      if (this.videoPlayAddress !== '') {
        this.videoPreview = true
        return
      }
      const { srcUrl, content } = this.msg
      const videoUrl = srcUrl || content
      this.videoPlayAddress = `${process.env.VUE_APP_CHAT_SERVER}/fastDfs/download?recordFile=${videoUrl}&isSafari=true`
      this.videoPreview = true
      this.videoCurrentTime = '00:00'
    },
    // 关闭按钮
    handleClosePreview() {
      this.$refs.videoBox.pause()
      this.videoPreview = false
    },
    // 播放按钮
    handlePlayMove() {
      this.$refs.videoBox.play()
      this.currentPausedStatus = false
    },
    // 暂停按钮
    handlePauseMove() {
      this.$refs.videoBox.pause()
      this.currentPausedStatus = true
    },
    // 视频可以播放时
    handleListenLoadPlay() {
      const videoBox = this.$refs.videoBox
      this.videoIsItPlayable = true
      this.videoCurrentTime = realFormatSecond(videoBox.currentTime) // 当前播放的秒数
      this.videoDuration = realFormatSecond(videoBox.duration) // 视频总长度
    },
    // 视频播放时
    videoTimeUpdate() {
      this.handleSetProgress()
    },
    // 加载进度条
    handleSetProgress() {
      const videoBox = this.$refs.videoBox
      if (videoBox) {
        this.progressCurrentTime = parseInt(videoBox.currentTime)
        this.videoCurrentTime = realFormatSecond(videoBox.currentTime)
        this.progressWidth = parseInt(videoBox.currentTime) / parseInt(videoBox.duration) * 100
        this.currentPausedStatus = videoBox.paused
      }
    },
    // 拖动进度条
    handleTouchStart(e) {
      const durationIcon = this.$refs.durationIcon
      const progress = this.$refs.progress
      const ev = e || window.event
      const touch = ev.targetTouches[0]
      this.offSetDistance = touch.clientX - durationIcon.offsetLeft - progress.offsetLeft// 鼠标相对于拖拽圆点的偏移距离
    },
    handleTouchMove(e) {
      const durationIcon = this.$refs.durationIcon
      const progress = this.$refs.progress
      const duration = this.$refs.duration
      const ev = e || window.event
      const touch = ev.targetTouches[0]
      const oLeft = touch.clientX - progress.offsetLeft - this.offSetDistance // 滑块最左端距离父元素最左端的距离
      // 拖动边界检测
      let durationWidth = oLeft
      if (oLeft < -durationIcon.offsetWidth / 2) {
        durationWidth = 0
      }
      if (oLeft + durationIcon.offsetWidth >= progress.offsetWidth) {
        durationWidth = progress.offsetWidth - durationIcon.offsetWidth
      }
      const rate = (durationWidth + durationIcon.offsetWidth) / progress.offsetWidth * 100
      this.$refs.videoBox.currentTime = (rate * this.$refs.videoBox.duration) / 100
      duration.style.width = durationWidth + 'px'
    },
    hadnleTouchEnd(e) {
      this.$refs.durationIcon.removeEventListener('touchmove', function(e) {
        e.preventDefault()
      })
    },
    handleTouchStartPc(e) {
    },
    handleTouchMovePc(e) {
    },
    hadnleTouchEndPc(e) {
    },
    handleClickDownVideo() {
      const { srcUrl } = this.msg
      const downUrl = process.env.VUE_APP_CHAT_SERVER + '/fastDfs/download?recordFile=' + srcUrl
      axios({
        method: 'get',
        url: downUrl, // 请求地址
        responseType: 'blob' // 表明返回服务器返回的数据类型
      }).then(res => {
        const content = res.data
        const blob = new Blob([content])
        const fileName = this.msg.fileName
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus">
  .fade-enter-active, .fade-leave-active
    transition opacity .3s
  .fade-enter, .fade-leave-to
    opacity 0
  .video-msg-wrapper
    width 136px
    height 130px
    border-radius 10px
    position relative
    overflow hidden
    &.is-self-video {
      display inline-block
    }
    .cover-image-wrapper
      img
        width 136px
        height 130px
        object-fit cover
    .mask-wrapper
      width 100%
      height 100%
      position absolute
      top 0
      left 0
      background rgba(0, 0, 0, 0.3)
      border-radius 10px
      display flex
      align-items center
      .play-btn
        width 36px
        height 36px
        background url('~@/assets/videoMsg/icon-play.png') no-repeat center center
        background-size 100% 100%
        position relative
        left 0
        right 0
        margin 0 auto
      .video-time
        position absolute
        right 10px
        bottom 10px
        font-size 12px
        font-family PingFangSC-Regular, PingFang SC
        font-weight 400
        color #FFFFFF
        line-height 20px
    .video-mask-container
      position: fixed;
      top 0
      left 0
      bottom 0
      right 0
      width 100%
      height 100%
      z-index 99999
      background rgba(0, 0, 0, 0.8)
      text-align justify
      display flex
      align-items center
      .video-container
        width 100%
        height 100%
        overflow hidden
        /*background-color #000000*/
        .close-btn-wrapper
          width 92%
          height 10%
          overflow hidden
          position relative
          margin 0 auto
          .icon-close
            width 28px
            height 28px
            position absolute
            left 0
            top 16px
            background url('~@/assets/videoMsg/icon-close.png') no-repeat center center
            background-size 100% 100%
            cursor pointer
        video
          width 100%
          height 80%
        .controls
          width 100%
          height 10%
          position relative
          box-sizing border-box
          overflow hidden
          display flex
          justify-content center
          .fixed-container
            width 92%
            position absolute
            bottom 24px
            color #FFFFFF
            display flex
            justify-content space-between
            align-items center
            .clickBtn
              width 24px
              height 24px
              cursor pointer
              .playbtn
                width 100%
                height 100%
                background url('~@/assets/videoMsg/controls-play.png') no-repeat center center
                background-size 100% 100%
              .pauseBtn
                width 100%
                height 100%
                background url('~@/assets/videoMsg/controls-pause.png') no-repeat center center
                background-size 100% 100%
            .down-load
              width 24px
              height 24px
              background url('~@/assets/videoMsg/controls-down.png') no-repeat center center
              background-size 100% 100%
              cursor pointer
            .progress-container
              width 100%
              height 24px
              display flex
              align-items center
              justify-content space-between
              margin 0 4%
              overflow hidden
              span
                font-size 16px
                color #FFFFFF
                font-family PingFangSC-Regular, PingFang SC
                white-space nowrap
              .progress
                width 100%
                height 2px
                margin 0 1.8%
                box-sizing border-box
                background-color #999999
                position relative
                display flex
                align-items center
                .duration
                  height 100%
                  background-color #FFFFFF
                .dragAndDrop
                  display inline-block
                  width 8px
                  height 8px
                  border-radius 50%
                  background-color #FFFFFF
                  cursor pointer
    @media screen and (min-width: 992px) {
      .video-mask-container {
        width 992px
        margin 0 auto
      }
    }
</style>
